export const ActionType = {
	OPEN_MULTIPLE_ORGAN_OFFERS_MODAL: 'foedus/OPEN_MULTIPLE_ORGAN_OFFERS_MODAL',
	CLOSE_MULTIPLE_ORGAN_OFFERS_MODAL: 'foedus/CLOSE_MULTIPLE_ORGAN_OFFERS_MODAL',
	OPEN_CHANGE_RECIPIENTS_MODAL: 'foedus/OPEN_CHANGE_RECIPIENTS_MODAL',
	CLOSE_CHANGE_RECIPIENTS_MODAL: 'foedus/CLOSE_CHANGE_RECIPIENTS_MODAL',
	OPEN_NOTIFICATION_MODAL: 'foedus/OPEN_NOTIFICATION_MODAL',
	CLOSE_NOTIFICATION_MODAL: 'foedus/CLOSE_NOTIFICATION_MODAL',
	OPEN_MESSAGE_MODAL: 'foedus/OPEN_MESSAGE_MODAL',
	CLOSE_MESSAGE_MODAL: 'foedus/CLOSE_MESSAGE_MODAL',
	OPEN_ACCEPT_ORGAN_OFFER_MODAL: 'foedus/OPEN_ACCEPT_ORGAN_OFFER_MODAL',
	CLOSE_ACCEPT_ORGAN_OFFER_MODAL: 'foedus/CLOSE_ACCEPT_ORGAN_OFFER_MODAL',
	OPEN_DECLINE_ORGAN_OFFER_MODAL: 'foedus/OPEN_DECLINE_ORGAN_OFFER_MODAL',
	CLOSE_DECLINE_ORGAN_OFFER_MODAL: 'foedus/CLOSE_DECLINE_ORGAN_OFFER_MODAL',
	OPEN_GRANT_ANONYMOUS_ACCESS_MODAL: 'foedus/OPEN_GRANT_ANONYMOUS_ACCESS_MODAL',
	CLOSE_GRANT_ANONYMOUS_ACCESS_MODAL: 'foedus/CLOSE_GRANT_ANONYMOUS_ACCESS_MODAL',
	SHOW_NOTIFICATION_ACTION_BUTTON: 'foedus/SHOW_NOTIFICATION_ACTION_BUTTON',
	HIDE_NOTIFICATION_ACTION_BUTTON: 'foedus/HIDE_NOTIFICATION_ACTION_BUTTON',
	SHOW_MESSAGE_ACTION_BUTTON: 'foedus/SHOW_MESSAGE_ACTION_BUTTON',
	HIDE_MESSAGE_ACTION_BUTTON: 'foedus/HIDE_MESSAGE_ACTION_BUTTON',
	SHOW_GRANT_ANONYMOUS_ACCESS_ACTION_BUTTON: 'foedus/SHOW_GRANT_ANONYMOUS_ACCESS_ACTION_BUTTON',
	HIDE_GRANT_ANONYMOUS_ACCESS_ACTION_BUTTON: 'foedus/HIDE_GRANT_ANONYMOUS_ACCESS_ACTION_BUTTON',
	SET_ORGAN_OFFER_ATTACHMENT_TYPE_IDS: 'foedus/SET_ORGAN_OFFER_ATTACHMENT_TYPE_IDS',
	SET_NATIONAL_BODY_CORE_CODEBOOK: 'foedus/SET_NATIONAL_BODY_CORE_CODEBOOK',
	SET_COUNTRY_CORE_CODEBOOK: 'foedus/SET_COUNTRY_CORE_CODEBOOK',
	SET_LOGGED_USER_PRIMARY_FOEDUS_ROLE: 'foedus/SET_LOGGED_USER_PRIMARY_FOEDUS_ROLE',
	SET_LOGGED_USER_COUNTRY: 'foedus/SET_LOGGED_USER_COUNTRY',
	SET_LOGGED_USER_FOEDUS_PERSON: 'foedus/SET_LOGGED_USER_FOEDUS_PERSON',
	SET_FOEDUS_ROLE_NAMES_FILTER: 'foedus/SET_FOEDUS_ROLE_NAMES_FILTER',
	SET_REG_DEVICES_UNIQUE_COUNTRIES: 'foedus/SET_REG_DEVICES_UNIQUE_COUNTRIES',
	SET_REG_DEVICES_UNIQUE_ORGANIZATIONS: 'foedus/SET_REG_DEVICES_UNIQUE_ORGANIZATIONS',
	SET_REG_DEVICES_UNIQUE_FOEDUS_PERSONS: 'foedus/SET_REG_DEVICES_UNIQUE_FOEDUS_PERSONS'
};
